import { Heading } from '@rabbit/elements/shared-components';
import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';

export interface BreadCrumbsItem {
  label: string;
  to?: string;
}

export interface BreadCrumbsProps {
  title?: string; // deprecated: kept for backward compatibility
  linkTo?: string; // deprecated: kept for backward compatibility
  items?: BreadCrumbsItem[]; // preferred structured API
}

export function BreadCrumbs({ title = '', linkTo, items }: BreadCrumbsProps) {
  let content: ReactNode = title;

  if (items && items.length > 0) {
    const lastIdx = items.length - 1;
    content = (
      <>
        {items.map((item, idx) => {
          const showLink = Boolean(item.to) && idx < lastIdx;
          return (
            <span key={`${item.label}-${idx}`}>
              {idx > 0 && ' > '}
              {showLink ? (
                <Link to={item.to as string} className="text-primary-600 no-underline hover:underline">
                  {item.label}
                </Link>
              ) : (
                item.label
              )}
            </span>
          );
        })}
      </>
    );
  } else if (linkTo) {
    // Fallback: maintain previous behavior parsing title
    const parts = title.split(' > ');
    if (parts.length > 1) {
      content = (
        <>
          {parts.map((part, idx) => {
            const isParent = idx === parts.length - 2;
            return (
              <span key={idx}>
                {idx > 0 && ' > '}
                {isParent ? (
                  <Link to={linkTo} className="text-primary-600 no-underline hover:underline">
                    {part}
                  </Link>
                ) : (
                  part
                )}
              </span>
            );
          })}
        </>
      );
    } else {
      content = (
        <Link to={linkTo} className="text-primary-600 no-underline hover:underline">
          {title}
        </Link>
      );
    }
  }

  return (
    <div className="border-b-[1px] py-4 pl-8">
      <Heading kind={'h2'}>{content}</Heading>
    </div>
  );
}

export default BreadCrumbs;
